/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * AMOP情報<br/> 支払方法が銀聯、Alipay、Paypalのいずれかである場合に設定する。
 */
export interface PaymentRequestAlternativePaymentMethod {
  /**
   * 支払方法<br/> 利用する支払方法を指定する。<br/> 設定値ごとの支払方法は以下とする。<br/> chinaUnionPay：銀聯<br/> alipay：Alipay<br/> paypal：Paypal
   */
  paymentMethod: PaymentRequestAlternativePaymentMethod.PaymentMethodEnum;
}
export namespace PaymentRequestAlternativePaymentMethod {
  export type PaymentMethodEnum = 'chinaUnionPay' | 'alipay' | 'paypal';
  export const PaymentMethodEnum = {
    ChinaUnionPay: 'chinaUnionPay' as PaymentMethodEnum,
    Alipay: 'alipay' as PaymentMethodEnum,
    Paypal: 'paypal' as PaymentMethodEnum,
  };
}
